import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {ApiStorageUnitFillerService, StorageUnitFillerContentDto, StorageUnitFillerDto} from '|api/document';
import {Observable} from 'rxjs';
import {
  CommonToolbarButtonValidators,
  StorageUnitFillerToolbarValidators,
} from '|shared';
import {DialogService} from '@icz/angular-modal';
import {AutoFocusDirective, PopoverComponent, PopoverContentDirective, SpinnerComponent} from '@icz/angular-essentials';
import {CdkOverlayOrigin} from '@angular/cdk/overlay';
import {FormAutocompleteComponent} from '@icz/angular-form-elements';
import {AsyncPipe} from '@angular/common';
import {
  Button, AbstractToolbarButtonsComponent,
  ButtonCollectionComponent,
  TOOLBAR_BUTTONS_COMPONENT_STYLES,
  TOOLBAR_BUTTONS_COMPONENT_TEMPLATE
} from '@icz/angular-table';

@Component({
  selector: 'icz-storage-unit-filler-content-toolbar-buttons',
    template: TOOLBAR_BUTTONS_COMPONENT_TEMPLATE,
    styles: TOOLBAR_BUTTONS_COMPONENT_STYLES,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SpinnerComponent, ButtonCollectionComponent, CdkOverlayOrigin, PopoverComponent, FormAutocompleteComponent, AutoFocusDirective, AsyncPipe, PopoverContentDirective]
})
export class StorageUnitFillerContentToolbarButtonsComponent extends AbstractToolbarButtonsComponent<StorageUnitFillerContentDto, void> {

  private apiStorageUnitFillerService = inject(ApiStorageUnitFillerService);
  private dialogService = inject(DialogService);

  @Input({required: true})
  storageUnitFiller!: StorageUnitFillerDto;

  protected getButtonObs(selection: Array<StorageUnitFillerContentDto>): Observable<Button[]> {
    return this.toolbarButtonsEvaluationService.evaluateToolbarButtons([
      {
        label: 'Vyloučit ze zpracování',
        icon: 'handover_to_distribution',
        buttonValidators: [
          CommonToolbarButtonValidators.isNoItemSelected(selection),
          StorageUnitFillerToolbarValidators.isNotStorageUnitPlanned([this.storageUnitFiller!])
        ],
        action: () => this.withdrawEntitiesFromFiller(selection),
      }
    ]);
  }

  private withdrawEntitiesFromFiller(selection: Array<StorageUnitFillerContentDto>) {
    this.dialogService.openQuestionDialogWithAnswer({
      title: 'Vyloučit entity ze zpracování',
      description: `Tuto operaci nelze vrátit.`,
      question: 'Opravdu chcete vyloučit entity ze zpracování?',
    }).subscribe(doExclude => {
      if (doExclude) {
        this.apiStorageUnitFillerService.storageUnitFillerBulkWithdrawEntities({
          id: this.storageUnitFiller.id,
          body: selection.map((s => s.id!))
        }).subscribe(_ => {
          this.operationCompleted.emit();
        });
      }
    });
  }

}
